/* eslint-disable react/forbid-prop-types */
import React from 'react';
import { Navigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import { getStringFromLS } from './shared/helper-utils/localStorage';
import { APP_USER_AUTH } from './saas/AppStorageStaticNames';

function PrivateRoute({ children }) {
  const userAuth = getStringFromLS(APP_USER_AUTH);
  if (!userAuth) {
    return <Navigate to="/login" replace />;
  }

  return children;
}

PrivateRoute.propTypes = {
  children: PropTypes.any.isRequired,
};

export default PrivateRoute;
